export const genDebounceFn = () => {
  let timerId: NodeJS.Timeout | undefined;

  return (callback: () => void, delay = 0) => {
    if (timerId) {
      clearTimeout(timerId);
    }

    timerId = setTimeout(() => callback?.(), delay);
  };
};
